import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface ToggleFiltersOptions {
  shouldPersist?: boolean
}

interface AppState {
  // Favorites
  favorites: string[]
  addFavorite: (id: string) => void
  removeFavorite: (id: string) => void
  isFavorite: (id: string) => boolean

  // Filters
  filtersVisible: boolean
  previousFiltersVisible: boolean
  showFilters: (options?: ToggleFiltersOptions) => void
  hideFilters: (options?: ToggleFiltersOptions) => void
}

const useAppStore = create<AppState>()(
  persist(
    (set, get) => ({
      favorites: [],
      addFavorite: (id) => set((state) => ({ favorites: [...state.favorites, id] })),
      removeFavorite: (id) => set((state) => ({ favorites: state.favorites.filter((favorite) => favorite !== id) })),
      isFavorite: (id) => get().favorites.includes(id),
      filtersVisible: false,
      previousFiltersVisible: false,
      showFilters: ({ shouldPersist } = { shouldPersist: true }) => {
        set((state) => {
          return { filtersVisible: shouldPersist ? true : state.filtersVisible, previousFiltersVisible: true }
        })
      },
      hideFilters: ({ shouldPersist } = { shouldPersist: true }) => {
        set((state) => {
          return { filtersVisible: shouldPersist ? false : state.filtersVisible, previousFiltersVisible: false }
        })
      },
      headerHeight: 0,
    }),
    {
      name: 'app-store',
      partialize: (state) => ({ filtersVisible: state.filtersVisible }),
    }
  )
)

export { useAppStore }
